import { render, staticRenderFns } from "./taksitliler.vue?vue&type=template&id=44e7a778"
import script from "./taksitliler.vue?vue&type=script&lang=js"
export * from "./taksitliler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports